import React, { createContext, useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { BrandProvider } from 'hooks/useBrand'
import { mqttConnect } from 'services/mqtt-service'
import GlobalStyle from 'config/styledGlobalStyle'
import Root from './routes'
import * as S from './styled'

export const MqttClientContext = createContext()

const App = () => {
  const mqttClient = mqttConnect()

  useEffect(() => {
    if (mqttClient) {
      mqttClient.on('error', err => {
        console.error('Connection error: ', err)
        mqttClient.end()
      })
    }
  }, [])

  return (
    <MqttClientContext.Provider value={mqttClient}>
      <BrandProvider>
        <GlobalStyle />
        <S.MasterContainer>
          <BrowserRouter>
            <Root />
          </BrowserRouter>
        </S.MasterContainer>
      </BrandProvider>
    </MqttClientContext.Provider>
  )
}

export default App
